import { ActionsMenu, Modal, ModalConfirm } from '@evertrue/et-components';
import { useFluxStore } from '@evertrue/et-flux';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import EverTrue from 'app';
import FilterStore from 'apps/filters/stores/filter-store';
import ListSource from 'apps/lists/sources/list-source';
import ExportSearchController from 'apps/export/controllers/export-search-controller';
import SaveSegmentController from 'apps/filters/controllers/save-segment-controller';
import ShareSegmentController from 'apps/filters/controllers/share-segment-controller';
import AddToFolderConfirmModal from 'apps/folder/components/modal/add-to-folder-confirm-modal';

const SegmentActions = ({ segment_id, segment_type, result_count, onExport, selected_segment, disabled }) => {
  const { active_filters } = useFluxStore(FilterStore, () => ({
    active_filters: FilterStore.getActiveFilters(),
  }));

  const hasActiveFilters = Array.isArray(active_filters) && active_filters.length > 0;

  const getOptions = () => {
    const options = [];

    const items = [];

    if (hasActiveFilters) {
      items.push(
        {
          id: 'save-search',
          icon: 'turned-in',
          label: 'Save Search Criteria',
          mountOnClick: ({ is_open, close }) => (
            <Modal isOpen={is_open} closeModal={close}>
              <SaveSegmentController segment_id={segment_id} requestHide={close} />
            </Modal>
          ),
        },
        {
          id: 'share-search',
          icon: 'share',
          label: 'Share Current Search Criteria',
          mountOnClick: ({ is_open, close }) => (
            <Modal isOpen={is_open} closeModal={close}>
              <ModalConfirm header="Share Current Search" onCancel={close}>
                <ShareSegmentController requestHide={close} />
              </ModalConfirm>
            </Modal>
          ),
        }
      );
    }

    items.push({
      id: 'export-results',
      icon: 'cloud-download',
      label: `Export ${numeral(result_count).format('0,0')} Results`,
      mountOnClick: ({ is_open, close }) => (
        <Modal isOpen={is_open} closeModal={close} size="medium">
          <ExportSearchController
            requestHide={close}
            onExport={onExport}
            exportText={`You are about to export ${result_count} records`}
          />
        </Modal>
      ),
    });

    if (segment_id && segment_type === 'saved_search') {
      items.push({
        id: 'delete-saved-search',
        icon: 'delete',
        className: 'text-danger',
        label: 'Delete Saved Search',
        onClick: () => {
          EverTrue.Alert.confirm(
            {
              content: 'Deleted saved searches cannot be recovered. Are you sure you want to delete this saved search?',
              headline: 'Delete Saved Search?',
              buttonLabel: 'Delete Saved Search',
            },
            (e) => {
              if (e) {
                ListSource.delete(segment_id, 'segments');
              }
            }
          );
        },
      });
      items.push({
        id: 'add-to-folder',
        icon: 'folder',
        iconKit: 'gt2',
        label: 'Add Saved Search to Folder',
        mountOnClick: ({ is_open, close }) => (
          <Modal isOpen={is_open} closeModal={close} size="dynamic">
            <AddToFolderConfirmModal requestHide={close} list={selected_segment} folderType="DYNAMIC" />
          </Modal>
        ),
      });
    }

    options.push({ id: 'segment-actions', items });
    return options;
  };

  return <ActionsMenu options={getOptions()} disabled={disabled} />;
};

SegmentActions.propTypes = {
  segment_id: PropTypes.number,
  segment_type: PropTypes.string,
  result_count: PropTypes.number,
  onExport: PropTypes.func,
  selected_segment: PropTypes.object,
  disabled: PropTypes.bool,
};

export default SegmentActions;
